"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterContains = filterContains;
exports.filterBool = filterBool;
exports.getSanitizedValue = getSanitizedValue;
exports.areAllColumnFiltersEmpty = areAllColumnFiltersEmpty;

var _every = _interopRequireDefault(require("lodash/every"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _values = _interopRequireDefault(require("lodash/values"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line complexity


function valueContainsFilterValue(filterValue, value) {
  if ((0, _isNil["default"])(filterValue) || (0, _isEmpty["default"])(filterValue)) {
    return true;
  }

  if ((0, _isNil["default"])(value)) {
    return false;
  }

  return value.toString().toUpperCase().indexOf(filterValue.toString().toUpperCase()) !== -1;
}

function filterContains(filterValue) {
  return function (value) {
    return valueContainsFilterValue(filterValue, value);
  };
}

function valueMatchesBoolFilter(filterValue, value) {
  if ((0, _isNil["default"])(filterValue)) {
    return true;
  }

  return filterValue === value;
}

function filterBool(filterValue) {
  return function (value) {
    return valueMatchesBoolFilter(filterValue, value);
  };
}

function getSanitizedValue(valueObject) {
  if (valueObject) {
    if (valueObject.value) {
      return valueObject.value;
    }
  }

  return '';
}

function areAllColumnFiltersEmpty(columnFilters) {
  var valueObjects = (0, _values["default"])(columnFilters);
  return (0, _every["default"])((0, _values["default"])(valueObjects), function (valueObject) {
    return !valueObject || !valueObject.value;
  });
}